//@vendor
const moment = require('moment');
const get = require('lodash/object/get');
const { createActions } = require('redux-actions');

//@actions
const { validateAndExecute } = require('actions/signaturePattern');
const { updateConsents } = require('actions/gdprConsents');
const { cancelDossier, retrieveAresDossier } = require('./aresDossier');

//@utilities
const { formatAmount } = require('utilities/currencyHelper');
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const DateHelper = require('utilities/dateHelper');
const download = require('downloadjs');
const BrowserUtils = require('utilities/browserUtils');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

// @core
const { formatText } = require('core/i18n').i18n;

//@constants
const { es: { DATE_FORMAT_WITH_SLASHES } } = require('commonsConstants/dateFormatTypes');
const { findPurposeById } = require('../components/contracts/contractPayrollLoan/payrollLoanPurposes');
const {
    DATE_FORMAT_API,
    PRODUCTION_ENVIRONMENT,
} = require('constants/index');
const {
    amortizationTypes,
    COLLECTIVE_MOCK_NAME,
    contractEasyLoan: { PAYMENT_DAY_END_OF_MONTH },
    loanPurposes,
    retailLoanCommons,
    payrollLoanCommon: { PRODUCT_TYPE, FINANCIADA, NO_FINANCIADA },
    payrollLoanLayoutKOxDTI,
    payrollLoanRecordStatus: { contractStatus },
    WIZARD_FIRST_STEP,
    payrollLoanDataPrecontractualEmail: {
        PRODUCT,
        STANDARD,
        SUBPRODUCT,
    },
} = require('../loansConstants/index');

const {
    PAYROLL_LOAN_LEGAL_CHECK,
} = require('constants/flagBasedFeatures');
const {
    PERSONAL_LOAN_DRAGO, NOT_ALLOWED_NEW_PERSONAL_LOAN_FLOW_COUNTRIES
} = require('constants/flagBasedFeatures');
//@helpers
const {
    downLoadDocumentInOtherPage,
} = require('../loansUtilities/loansHelper');
const apiURLBuilder = require('core/apiURLBuilder');
const translationContractLoanPdfViewerINE = require("../components/contracts/contractLoanPdfViewerINE/contractLoanPdfViewerINE.translations");

// Actions in alphabetic order
const simpleActions = createActions(
    'CONTRACT_PAYROLL_LOAN_APPROVE_RECORD',
    'CONTRACT_PAYROLL_LOAN_APPROVE_RECORD_APPROVED',
    'CONTRACT_PAYROLL_LOAN_APPROVE_RECORD_ERROR',

    'CONTRACT_PAYROLL_LOAN_DOWNLOAD_ZIP_DOCUMENT',
    'CONTRACT_PAYROLL_LOAN_DOWNLOAD_ZIP_DOCUMENT_ERROR',
    'CONTRACT_PAYROLL_LOAN_DOWNLOAD_ZIP_DOCUMENT_SUCCESS',

    'CONTRACT_PAYROLL_LOAN_FORMALIZE',
    'CONTRACT_PAYROLL_LOAN_FORMALIZE_ERROR',
    'CONTRACT_PAYROLL_LOAN_FORMALIZE_SUCCESS',

    'CONTRACT_PAYROLL_LOAN_HIDE_NEW_OFFER_VIEW',

    'CONTRACT_PAYROLL_LOAN_HIRING_DOCUMENTS',
    'CONTRACT_PAYROLL_LOAN_HIRING_DOCUMENTS_ERROR',
    'CONTRACT_PAYROLL_LOAN_HIRING_DOCUMENTS_SUCCESS',

    'CONTRACT_PAYROLL_LOAN_DOWNLOAD_PRINT_DOCUMENT',
    'CONTRACT_PAYROLL_LOAN_DOWNLOAD_PRINT_DOCUMENT_ERROR',
    'CONTRACT_PAYROLL_LOAN_DOWNLOAD_PRINT_DOCUMENT_SUCCESS',

    'CONTRACT_PAYROLL_LOAN_GET_PURPOSES',
    'CONTRACT_PAYROLL_LOAN_GET_PURPOSES_ERROR',
    'CONTRACT_PAYROLL_LOAN_GET_PURPOSES_SUCCESS',

    'CONTRACT_PAYROLL_LOAN_INITIALIZE',
    'CONTRACT_PAYROLL_LOAN_INITIALIZE_ERROR',
    'CONTRACT_PAYROLL_LOAN_INITIALIZE_SUCCESS',

    'CONTRACT_PAYROLL_LOAN_INSTALLMENT',
    'CONTRACT_PAYROLL_LOAN_INSTALLMENT_ERROR',
    'CONTRACT_PAYROLL_LOAN_INSTALLMENT_SUCCESS',

    'CONTRACT_PAYROLL_LOAN_OFFER_DTI',
    'CONTRACT_PAYROLL_LOAN_OFFER_DTI_ERROR',
    'CONTRACT_PAYROLL_LOAN_OFFER_DTI_SUCCESS',

    'CONTRACT_PAYROLL_LOAN_OFFER',
    'CONTRACT_PAYROLL_LOAN_OFFER_ERROR',
    'CONTRACT_PAYROLL_LOAN_OFFER_SUCCESS',

    'CONTRACT_PAYROLL_LOAN_PROPOSITION',
    'CONTRACT_PAYROLL_LOAN_PROPOSITION_ERROR',
    'CONTRACT_PAYROLL_LOAN_PROPOSITION_SUCCESS',

    'CONTRACT_PAYROLL_LOAN_MIN_TERM',
    'CONTRACT_PAYROLL_LOAN_MIN_TERM_ERROR',
    'CONTRACT_PAYROLL_LOAN_MIN_TERM_SUCCESS',

    'CONTRACT_PAYROLL_LOAN_RESET_DOCUMENT_AND_AGREE_CHECKBOX',
    'CONTRACT_PAYROLL_LOAN_RESET_STATE',

    'CONTRACT_PAYROLL_LOAN_SAVE_IN_PROGRESS_ERROR',

    'CONTRACT_PAYROLL_LOAN_SET_ACCOUNT',
    'CONTRACT_PAYROLL_LOAN_SET_AGREE',
    'CONTRACT_PAYROLL_LOAN_SET_COLLECTIVE',
    'CONTRACT_PAYROLL_LOAN_SET_INACTIVE_ACCOUNT',
    'CONTRACT_PAYROLL_LOAN_SET_LOAN_AMOUNT',
    'CONTRACT_PAYROLL_LOAN_SET_LOAN_AMOUNT_NEW_OFFER',
    'CONTRACT_PAYROLL_LOAN_SET_PAYMENT_DAY',
    'CONTRACT_PAYROLL_LOAN_SET_TERM',
    'CONTRACT_PAYROLL_LOAN_SET_TERM_NEW_OFFER',
    'CONTRACT_PAYROLL_LOAN_SET_VISIBLE_STEP',

    'CONTRACT_PAYROLL_LOAN_UPDATE_OFFER',
    'CONTRACT_PAYROLL_LOAN_UPDATE_OFFER_ERROR',
    'CONTRACT_PAYROLL_LOAN_UPDATE_OFFER_SUCCESS',

    'CONTRACT_PAYROLL_LOAN_VALIDATE_STEP',
    'CONTRACT_PAYROLL_LOAN_INIT_SUCCESS',
    'CONTRACT_PAYROLL_LOAN_INIT_ERROR',
    'GET_PAYROLL_LOAN_POLICY_DOCUMENT_SUCCESS',
    'GET_PAYROLL_LOAN_POLICY_DOCUMENT_ERROR',
    'GET_PAYROLL_LOAN_EXPEDIENT_INE_SUCCESS',
    'GET_PAYROLL_LOAN_INE_DOCUMENT_SUCCESS',
    'GET_PAYROLL_LOAN_INE_DOCUMENT_ERROR',
    'CONTRACT_PAYROLL_LOAN_READ_DOCUMENT',
    'CONTRACT_PAYROLL_LOAN_CHECKED_RADIO_BUTTON',
    'CONTRACT_PAYROLL_LOAN_PRINT_DOCUMENT',
    'CONTRACT_PAYROLL_LOAN_HIRING_IS_FETCHING_DOCUMENTS',

);

const contractPayrollLoanSaveInProgress = () => (dispatch, getState) => {
    const immPayrollLoan = getState().contractPayrollLoan;
    const params = {
        query: {
            amount: immPayrollLoan.get('selectedAmount'),
            purpose: immPayrollLoan.get('selectedPurpose'),
            recordId: immPayrollLoan.get('recordId'),
            term: immPayrollLoan.get('selectedTerm'),
            userType: immPayrollLoan.get('userType'),
            financialInformation: {
                additionalPayments: immPayrollLoan.getIn(['income', 'extra']),
                housingType: immPayrollLoan.get('regime'),
                jobSeniorityInMonths: parseInt(immPayrollLoan.get('companyMonths')) || '',
                jobSeniorityInYears: parseInt(immPayrollLoan.get('companyYears')) || '',
                jobType: immPayrollLoan.get('job'),
                maritalStatus: immPayrollLoan.get('civilStatus'),
                mortgageFee: immPayrollLoan.getIn(['outcome', 'mortgage']),
                netIncome: immPayrollLoan.getIn(['income', 'amount']),
                numberOfCreditCards: immPayrollLoan.get('creditCards'),
                otherLoanInstallments: immPayrollLoan.getIn(['outcome', 'others']),
                rent: immPayrollLoan.getIn(['outcome', 'rent'])
            }
        }
    };

    return APIPost({ dispatch, endpoint: 'payrollLoanSaveInProgress', params })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractPayrollLoanSaveInProgressError({ response: response.error }));
            } else {
                throw response;
            }
        });
};

const setLoanAmountNewOffer = selectedAmount => dispatch => {
    dispatch(simpleActions.contractPayrollLoanSetLoanAmountNewOffer(selectedAmount));
    dispatch(contractPayrollLoanSaveInProgress());
};

const setLoanTermNewOffer = term => dispatch => {
    dispatch(simpleActions.contractPayrollLoanSetTermNewOffer(term));
    dispatch(contractPayrollLoanSaveInProgress());
};

const formalizeQuery = () => (dispatch, getState) => {
    const immPayrollLoan = getState().contractPayrollLoan;
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const immAccounts = getState().accounts.get('byId');

    const immProposition = immPayrollLoan.get('proposition');
    const immAccount = immAccounts.get(immPayrollLoan.get('selectedAccount'));
    const fechaVencimiento = immProposition.get('loanDueDate');
    const operationProcessId = immPayrollLoan.get('payrollInitOperationProcessId')
    const textOfficine = formatText('contractEasyLoan-documentsAssociatedConfirmPage')
    const acceptanceText = __CONTACT_CENTER__ ? textOfficine : formatText('contractPayrollLoanStepTwo-contractPayrollLoanStepTwo_title_legal_component')
    const scrollDown = immPayrollLoan.get('scrollDown')
    let diaPagoFinMes;
    let fechaPrimerCargo;

    if (immPayrollLoan.get('paymentDaySelected') === PAYMENT_DAY_END_OF_MONTH) {
        diaPagoFinMes = amortizationTypes.YES;
        fechaPrimerCargo = immProposition.get('lackDate') || immProposition.get('chargeOffDate');
    } else {
        diaPagoFinMes = amortizationTypes.NO;
        fechaPrimerCargo = immProposition.get('chargeOffAnniversaryDate');
    }

    const formattedInstallmentAmount = formatAmount(immPayrollLoan.getIn(['installment', 'amount']));
    const params = {
        header: {
            version: 2
        },
        query: {
            accountBban: immAccount.getIn(['ibanComplex', 'codbban']),
            accountContractNumber: immAccount.get('newContractNumber'),
            accountPrefix: immAccount.getIn(["ibanComplex", "pais"]) + immAccount.getIn(["ibanComplex", "digitodecontrol"]), // IBAN
            capitalizedOpeningCommissionIndicator: immPayrollLoan.get('indCapson'),
            dueDate: fechaVencimiento,
            endOfMonth: immPayrollLoan.get('paymentDaySelected') === PAYMENT_DAY_END_OF_MONTH,
            endOfMonthDate: diaPagoFinMes,
            financedCommission: !!immPayrollLoan.get('indCapson'),
            firstChargeDate: fechaPrimerCargo,
            installment: formattedInstallmentAmount,
            product: immAccount.get('newProduct'),
            propositionContractNumber: immProposition.get('contractNumber'),
            propositionContractProduct: immProposition.get('productNumber'),
            propositionNumber: immProposition.get('propositionNumber'),
            registerDate: moment().startOf('day').format(DATE_FORMAT_API),
            tae: formatAmount(immPayrollLoan.get('tae')),
            year: immProposition.get('propositionYear'),
            productType: PRODUCT_TYPE,
            termsAndConds: {},
            operationProcessId,
            acceptanceText,
            scrollDown,
            documentId: immPayrollLoan.get("filePayrollLoanPolicyDocumentId"),
        }
    };

    if (immFlagBasedFeatures.get(PAYROLL_LOAN_LEGAL_CHECK)) {


        const textOfficine = formatText('contractEasyLoan-documentsAssociatedConfirmPage')
        const acceptedText = __CONTACT_CENTER__ ? textOfficine : formatText('contractPayrollLoanStepTwo_title_legal_component_contractPayrollLoanStepTwo')

        const termsAndConds = {
            acceptedText,
            dateTimeToSave: immPayrollLoan.get('timesTampCheckBox'),
        }
        params.query.termsAndConds = termsAndConds;
    }

    return APIPost({ dispatch, endpoint: 'payrollLoanFormalize', params });
};

const formalizeProcess = () => (dispatch, getState) => {
    dispatch(retrieveAresDossier())
        .then(() => dispatch(cancelDossier()))
        .then(() => dispatch(formalizeQuery()))
        .then(() => dispatch(simpleActions.contractPayrollLoanFormalizeSuccess()))
        .catch(response => dispatch(simpleActions.contractPayrollLoanFormalizeError({ error: response && response.error })));
};

const acceptBestOffer = () => (dispatch, getState) => {
    const immPayrollLoan = getState().contractPayrollLoan;

    const params = {
        query: {
            amount: immPayrollLoan.get('selectedAmount'),
            recordId: immPayrollLoan.get('recordId'),
            term: immPayrollLoan.get('selectedTerm')
        }
    };

    return APIPost({ dispatch, endpoint: 'payrollLoanAcceptBestOffer', params })
        .then(response => {
            dispatch(simpleActions.contractPayrollLoanUpdateOfferSuccess({ response }));
            dispatch(formalizeProcess());
        }).catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractPayrollLoanUpdateOfferError({ error: response.error }));
            } else {
                throw response;
            }
        });
};

const rejectBestOffer = () => (dispatch, getState) => {
    const immPayrollLoan = getState().contractPayrollLoan;

    const params = {
        query: {
            recordId: immPayrollLoan.get('recordId')
        }
    };

    return APIPost({ dispatch, endpoint: 'payrollLoanRejectBestOffer', params })
        .then(response => {
            dispatch(simpleActions.contractPayrollLoanUpdateOfferSuccess({ response }));
            dispatch(formalizeProcess());
        }).catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractPayrollLoanUpdateOfferError({ error: response.error }));
            } else {
                throw response;
            }
        });
};

const updateOffer = () => (dispatch, getState) => {
    const immPayrollLoan = getState().contractPayrollLoan;
    const changed = immPayrollLoan.getIn(['offer', 'changed']);

    dispatch(simpleActions.contractPayrollLoanUpdateOffer());
    if (changed) {
        dispatch(acceptBestOffer());
    } else {
        dispatch(rejectBestOffer());
    }
};

const getInstallment = () => (dispatch, getState) => {
    const immPayrollLoan = getState().contractPayrollLoan;
    const endOfMonth = immPayrollLoan.get('paymentDaySelected') === PAYMENT_DAY_END_OF_MONTH;
    const product = immPayrollLoan.get('productType');
    const subProduct = immPayrollLoan.get('productSubType');
    const standardCode = endOfMonth ? immPayrollLoan.get('endOfMonthReferenceStandard') :
        immPayrollLoan.get('productStandard');

    const params = {
        query: {
            capIndicator: 'N',
            intIndicator: 'N',
            currency: immPayrollLoan.get('currency'),
            amount: immPayrollLoan.get('selectedAmount'),
            priceIndicator: 'E',
            term: immPayrollLoan.get('selectedTerm'),
            productType: PRODUCT_TYPE,
            product,
            subProduct,
            standardCode,
            openingCommission: immPayrollLoan.get('arrangementFee'),
            tin: immPayrollLoan.get('tin')
        }
    };

    dispatch(simpleActions.contractPayrollLoanInstallment());
    return APIGet({ dispatch, endpoint: 'payrollLoanInstallment', params })
        .then(response => {
            dispatch(simpleActions.contractPayrollLoanInstallmentSuccess({ response }));
        }).catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractPayrollLoanInstallmentError({ error: response.error }));
            } else {
                throw response;
            }
        });
};

const getOfferDTI = () => (dispatch, getState) => {
    const immPayrollLoan = getState().contractPayrollLoan;

    const params = {
        query: {
            maxInstallment: immPayrollLoan.get('maxInstallment'),
            tin: immPayrollLoan.get('tin'),
            selectedAmount: immPayrollLoan.get('selectedAmount')
        }
    };

    dispatch(simpleActions.contractPayrollLoanOfferDti());
    return APIGet({ dispatch, endpoint: 'payrollLoanMinTerm', params })
        .then(response => {
            dispatch(simpleActions.contractPayrollLoanOfferDtiSuccess({ response }));
        }).catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractPayrollLoanOfferDtiError({ error: response.error }));
            } else {
                throw response;
            }
        });
};

const getBestOffer = () => (dispatch, getState) => {
    const immPayrollLoan = getState().contractPayrollLoan;

    const maxTerm = false;
    const term = maxTerm ? payrollLoanLayoutKOxDTI.MAX_TERM : immPayrollLoan.get('selectedTerm');

    const params = {
        query: {
            maxInstallment: immPayrollLoan.get('maxInstallment'),
            inCollective: immPayrollLoan.get('isCollective'),
            tin: immPayrollLoan.get('tin'),
            term
        }
    };

    return APIGet({ dispatch, endpoint: 'payrollLoanMaxAmount', params })
        .then(response => {
            dispatch(simpleActions.contractPayrollLoanOfferSuccess({ response }));
        }).catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractPayrollLoanOfferError({ error: response.error }));
            } else {
                throw response;
            }
        });
};

const getOffer = () => (dispatch, getState) => {
    const immPayrollLoan = getState().contractPayrollLoan;
    const showNewOfferView = immPayrollLoan.get('showNewOfferView');
    const status = immPayrollLoan.get('preApprovalState');
    const biggerImport = status === get(contractStatus, contractStatus.MEJOR_OFERTA);

    dispatch(simpleActions.contractPayrollLoanOffer());
    if (biggerImport) {
        dispatch(getBestOffer());
    } else if (showNewOfferView) {
        dispatch(getOfferDTI()).then(() => {
            dispatch(getInstallment());
        });
    } else {
        dispatch(getInstallment());
    }
};

const getPurposes = () => dispatch => {
    dispatch(simpleActions.contractPayrollLoanGetPurposes());
    APIGet({ dispatch, endpoint: 'payrollLoanGetPurposes' })
        .then(response => {
            dispatch(simpleActions.contractPayrollLoanGetPurposesSuccess({ response }));
        }).catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractPayrollLoanGetPurposesError());
            } else {
                throw response;
            }
        });
}

const contractInitialize = collectiveParam => (dispatch, getState) => {
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const isDragoFeature = immFlagBasedFeatures.get(PERSONAL_LOAN_DRAGO);

    dispatch(simpleActions.contractPayrollLoanInitialize());
    return APIGet({ dispatch, endpoint: 'contractLoanInitialize' })
        .then(response => {
            let modifiedResponse = response;
            if (__ENVIRONMENT__ !== PRODUCTION_ENVIRONMENT && collectiveParam) {
                modifiedResponse.inCollective = collectiveParam === 'true';
                modifiedResponse.collectiveInformation = [{ 'name': COLLECTIVE_MOCK_NAME }]
            }
            if (isDragoFeature) {
                dispatch(getPurposes());
            }
            dispatch(simpleActions.contractPayrollLoanInitializeSuccess({ response: modifiedResponse }));
            dispatch(getInstallment());
            dispatch(getOffer());
        }).catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractPayrollLoanInitializeError({ error: response.error }));
            } else {
                throw response;
            }
        });
};

const downloadLoanContractDocument = () => (dispatch, getState) => {
    const immContractPayrollLoan = getState().contractPayrollLoan;
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const isDragoFeature = immFlagBasedFeatures.get(PERSONAL_LOAN_DRAGO);
    const immAccounts = getState().accounts;

    let selectedPurpose = findPurposeById(immContractPayrollLoan.get('selectedPurpose'));
    if (isDragoFeature) {
        const finalPurpose = immContractPayrollLoan.get('newPurposesList').find(purposeElement => purposeElement.get('id') === immContractPayrollLoan.get('selectedPurposeDrago'));
        selectedPurpose = finalPurpose.get('text');
    }

    const params = {
        header: {
            responseType: 'arraybuffer'
        },

        query: {
            year: immContractPayrollLoan.getIn(['proposition', 'propositionYear']),
            clientAccountCode: immAccounts.getIn(['byId', immContractPayrollLoan.get('selectedAccount'), 'iban']),
            productDuration: immContractPayrollLoan.get('selectedTerm').toString(),
            dueDate: DateHelper.formatDate(immContractPayrollLoan.getIn(['proposition', 'vencDate']), DATE_FORMAT_WITH_SLASHES),
            endOfMonth: immContractPayrollLoan.get('paymentDaySelected') === PAYMENT_DAY_END_OF_MONTH,
            loanPurpose: selectedPurpose ? formatText(selectedPurpose.text) : undefined,
            amount: formatAmount(immContractPayrollLoan.get('selectedAmount'), 'es'),
            capitalizedOpeningCommissionIndicator: immContractPayrollLoan.get('indCapson'),
            propositionContractNumber: immContractPayrollLoan.getIn(['proposition', 'contractNumber']),
            propositionNumber: immContractPayrollLoan.getIn(['proposition', 'propositionNumber']),
            firstTime: true, //fixed value. The user hasn't contracted the loan yet in this step. So we show a template.
            tae: formatAmount(immContractPayrollLoan.get('tae'), 'es'),
            productType: PRODUCT_TYPE
        }
    };

    dispatch(simpleActions.contractPayrollLoanDownloadPrintDocument());
    APIPost({ dispatch, endpoint: 'requestEasyLoanContractDocument', params }).then(response => {
        const content = get(response, 'xhr.response');
        downLoadDocumentInOtherPage(content);
        dispatch(simpleActions.contractPayrollLoanDownloadPrintDocumentSuccess());
    })
        .catch(() => {
            dispatch(simpleActions.contractPayrollLoanDownloadPrintDocumentError());
        });
};

const downloadINEDocument = () => (dispatch, getState) => {
    const immContractPayrollLoan = getState().contractPayrollLoan;

    const params = {
        header: {
            responseType: 'arraybuffer'
        },
        query: {
            year: immContractPayrollLoan.getIn(['proposition', 'propositionYear']),
            calculatedOpeningCommission: formatAmount(immContractPayrollLoan.get('arrangementFee')),
            financedCommission: (immContractPayrollLoan.get('indCapson') === amortizationTypes.YES) ? FINANCIADA : NO_FINANCIADA,
            productDuration: immContractPayrollLoan.get('selectedTerm').toString(),
            dueDate: moment(immContractPayrollLoan.getIn(['proposition', 'vencDate'])).format(DATE_FORMAT_WITH_SLASHES),
            endOfMonth: immContractPayrollLoan.get('paymentDaySelected') === PAYMENT_DAY_END_OF_MONTH,
            amount: formatAmount(immContractPayrollLoan.get('selectedAmount')),
            propositionContractNumber: immContractPayrollLoan.getIn(['proposition', 'contractNumber']),
            propositionNumber: immContractPayrollLoan.getIn(['proposition', 'propositionNumber']).toString(),
            firstTime: true, //fixed value. The user hasn't contracted the loan yet in this step. So we show a template.
            tae: formatAmount(immContractPayrollLoan.get('tae')),
            tin: formatAmount(immContractPayrollLoan.get('tin')),
            productType: PRODUCT_TYPE
        }
    };

    dispatch(simpleActions.contractPayrollLoanDownloadPrintDocument());
    APIPost({ dispatch, endpoint: 'contractEasyLoanINEDocument', params }).then(response => {
        const content = get(response, 'xhr.response');
        downLoadDocumentInOtherPage(content);
        dispatch(simpleActions.contractPayrollLoanDownloadPrintDocumentSuccess());
    })
        .catch(() => {
            dispatch(simpleActions.contractPayrollLoanDownloadPrintDocumentError());
        });
};

const onDownloadDocument = () => (dispatch, getState) => {
    const immPayrollLoan = getState().contractPayrollLoan;
    const immProposition = immPayrollLoan.get('proposition');
    const accounts = getState().accounts;

    const isFetchingZip = immPayrollLoan.get('isFetchingZip');
    if (!isFetchingZip) {
        const financedCommission = immPayrollLoan.get('indCapson') === amortizationTypes.YES ? FINANCIADA : NO_FINANCIADA;
        const selectedAccount = immPayrollLoan.get('selectedAccount');

        const params = {
            header: {
                responseType: 'arraybuffer'
            },
            query: {
                amount: formatAmount(immPayrollLoan.get('selectedAmount')),
                calculatedOpeningCommission: formatAmount(immPayrollLoan.get('arrangementFee')),
                capitalizedOpeningCommissionIndicator: immPayrollLoan.get('indCapson'),
                clientAccountCode: accounts.getIn(['byId', selectedAccount, 'iban']),
                dueDate: moment(immProposition.get('loanDueDate')).format(DATE_FORMAT_WITH_SLASHES),
                endOfMonth: immPayrollLoan.get('paymentDaySelected') === PAYMENT_DAY_END_OF_MONTH,
                financedCommission,
                firstTime: true, //fixed value. The user hasn't contracted the loan yet in this step. So we show a template.
                loanPurpose: loanPurposes[immPayrollLoan.get('selectedPurpose')],
                productDuration: immPayrollLoan.get('selectedTerm').toString(),
                propositionContractNumber: immPayrollLoan.get('contractNumber'),
                propositionNumber: immPayrollLoan.getIn(['proposition', 'propositionNumber']).toString(),
                tae: formatAmount(immPayrollLoan.get('tae')),
                tin: formatAmount(immPayrollLoan.get('tin')),
                year: immPayrollLoan.getIn(['proposition', 'propositionYear']),
                productType: PRODUCT_TYPE
            }
        };

        dispatch(simpleActions.contractPayrollLoanDownloadZipDocument());
        APIPost({ dispatch, endpoint: 'loanHiringDocumentsZip', params })
            .then(response => {
                dispatch(simpleActions.contractPayrollLoanDownloadZipDocumentSuccess());
                download(response.xhr.response, 'documentosPrestamoPersonal.zip', 'application/zip');
            }).catch(response => {
                if (!!response.error) {
                    dispatch(simpleActions.contractPayrollLoanDownloadZipDocumentError({ error: response.error }));
                } else {
                    throw response;
                }
            });
    }
};

const onPrintDocument = () => (dispatch, getState) => {
    const immPayrollLoan = getState().contractPayrollLoan;
    const documents = immPayrollLoan.get('documents');
    const data = [new Uint8Array(documents)];
    const blobObject = new Blob(data, { type: 'application/pdf' });

    if (BrowserUtils.browserIsIE()) {
        window.navigator.msSaveOrOpenBlob(blobObject);
    } else {
        const blobURL = window.URL.createObjectURL(blobObject);
        const winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
            'resizable,screenX=50,screenY=50,width=850,height=1050';
        const printWindow = window.open(blobURL, '', winparams);

        if (printWindow) {
            printWindow.print();
        }
    }
};

const getHiringDocuments = () => (dispatch, getState) => {
    const immPayrollLoan = getState().contractPayrollLoan;
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const isDragoFeature = immFlagBasedFeatures.get(PERSONAL_LOAN_DRAGO);
    const accounts = getState().accounts;

    const selectedPurpose = isDragoFeature ? immPayrollLoan.get('selectedPurpose') : findPurposeById(immPayrollLoan.get('selectedPurpose'));
    const loanPurpose = selectedPurpose ? formatText(selectedPurpose.text) : undefined;

    const selectedAccount = immPayrollLoan.get('selectedAccount');
    const financedCommission = immPayrollLoan.get('indCapson') === amortizationTypes.YES ?
        FINANCIADA : NO_FINANCIADA;
    const immProposition = immPayrollLoan.get('proposition');

    const params = {
        header: {
            responseType: 'arraybuffer'
        },
        query: {
            amount: formatAmount(immPayrollLoan.get('selectedAmount')),
            calculatedOpeningCommission: formatAmount(immPayrollLoan.get('arrangementFee')),
            capitalizedOpeningCommissionIndicator: immPayrollLoan.get('indCapson'),
            clientAccountCode: accounts.getIn(['byId', selectedAccount, 'iban']),
            dueDate: moment(immProposition.get('loanDueDate')).format(DATE_FORMAT_WITH_SLASHES),
            endOfMonth: immPayrollLoan.get('paymentDaySelected') === PAYMENT_DAY_END_OF_MONTH,
            financedCommission,
            firstTime: true, //fixed value. The user hasn't contracted the loan yet in this step. So we show a template.
            loanPurpose,
            productDuration: immPayrollLoan.get('selectedTerm').toString(),
            propositionContractNumber: immProposition.get('contractNumber'),
            propositionNumber: immProposition.get('propositionNumber').toString(),
            tae: formatAmount(immPayrollLoan.get('tae')),
            tin: formatAmount(immPayrollLoan.get('tin')),
            year: immProposition.get('propositionYear'),
            productType: PRODUCT_TYPE
        }
    };

    dispatch(simpleActions.contractPayrollLoanHiringDocuments());
    APIPost({ dispatch, endpoint: 'loanHiringDocuments', params })
        .then(response => {
            dispatch(simpleActions.contractPayrollLoanHiringDocumentsSuccess({ documents: response.xhr.response }));
        }).catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractPayrollLoanHiringDocumentsError({ error: response.error }));
            } else {
                throw response;
            }
        });
};

const getMinTerm = () => (dispatch, getState) => {
    const immPayrollLoan = getState().contractPayrollLoan;

    const params = {
        query: {
            maxInstallment: immPayrollLoan.get('maxInstallment'),
            tin: immPayrollLoan.get('tin'),
            selectedAmount: immPayrollLoan.get('selectedAmount')
        }
    };

    dispatch(simpleActions.contractPayrollLoanMinTerm());
    return APIGet({ dispatch, endpoint: 'payrollLoanMinTerm', params })
        .then(response => {
            dispatch(simpleActions.contractPayrollLoanMinTermSuccess({ minTerm: response.minTerm }));
        }).catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractPayrollLoanMinTermError({ error: response }));
            }
        });
};

const getRemainingInfo = (propositionNumber, propositionYear, contractNumber, productNumber) => dispatch => {
    const params = {
        query: {
            anio: propositionYear,
            numeroPropuesta: propositionNumber
        }
    };
    const promises = [];

    const amortizationPromise = APIGet({
        dispatch,
        params,
        endpoint: 'contractEasyLoanAmortizationAmortization'
    });
    promises.push(amortizationPromise);

    const initialDataPromise = APIGet({
        dispatch,
        params,
        endpoint: 'contractEasyLoanInitialData'
    });
    promises.push(initialDataPromise);

    return Promise.all(promises).then(responses => {
        const amortizationReponse = responses[0];
        const initialDataResponse = responses[1];
        return dispatch(
            simpleActions.contractPayrollLoanPropositionSuccess({
                propositionNumber,
                propositionYear,
                contractNumber,
                lackDate: initialDataResponse.fechaFinCarencia,
                loanDueDate: initialDataResponse.fechaVctoPrestamos,
                chargeOffDate: amortizationReponse.fechaAmortiz,
                chargeOffAnniversaryDate: get(amortizationReponse, 'listaFechasAmortiz.fechaAmortiz.0.fechaAmortiz1'),
                productNumber
            })
        );
    })
};

const getProposition = () => (dispatch, getState) => {
    const immPayrollLoan = getState().contractPayrollLoan;
    const isCollective = immPayrollLoan.get('isCollective');
    const productDetail = isCollective ? immPayrollLoan.getIn(['collectiveInformation', '0', 'productDetail']) : null;
    const standard = immPayrollLoan.get('paymentDagiySelected') === PAYMENT_DAY_END_OF_MONTH ?
        immPayrollLoan.get('endOfMonthReferenceStandard') : immPayrollLoan.get('productStandard');
    const codigodeestandar = isCollective ? productDetail.get('standardCode') : standard;
    const subtipodeproducto = isCollective ? productDetail.get('subType') : immPayrollLoan.get('productSubType');
    const tipodeproducto = isCollective ? productDetail.get('type') : immPayrollLoan.get('productType');

    const params = {
        query: {
            indCapson: immPayrollLoan.get('indCapson'),
            importePpta: {
                importe: immPayrollLoan.get('selectedAmount'),
                divisa: immPayrollLoan.get('currency')
            },
            plazoPpta: {
                numerodeunidades: immPayrollLoan.get('selectedTerm'),
                unidaddetiempo: 'M' // Fixed Value
            },
            finalidadPpta: '99', // Fixed Value
            tipoPreciosOpera: 'E', // Fixed Value
            canalOperacion: 'RED', // Fixed Value
            estandar: {
                codigodeestandar,
                subtipodeproducto: {
                    subtipodeproducto,
                    tipodeproducto: {
                        tipodeproducto
                    }
                }
            }
        }
    };

    dispatch(simpleActions.contractPayrollLoanProposition());
    return APIPost({ dispatch, endpoint: 'contractEasyLoanPropositionNumber', params })
        .then(response => {
            const propositionNumber = get(response, 'propuesta.numerodepropuesta');
            const propositionYear = get(response, 'propuesta.anio');
            const contractNumber = get(response, 'contrato.numerodecontrato');
            const productNumber = get(response, 'contrato.producto');
            return dispatch(getRemainingInfo(propositionNumber, propositionYear, contractNumber, productNumber));
        }).catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractPayrollLoanPropositionError({ error: response.error }));
            } else {
                throw response;
            }
        });
};

const formalizeCallback = (dispatch, getState) => {

    const status = getState().contractPayrollLoan.get('preApprovalState');
    const biggerImport = status === get(contractStatus, contractStatus.MEJOR_OFERTA);

    dispatch(simpleActions.contractPayrollLoanFormalize());
    if (biggerImport) {
        dispatch(updateOffer());
    } else {
        dispatch(formalizeProcess());
    }
};

const formalize = () => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        dispatch(updateConsents(dataToken))
            .then(() => formalizeCallback(dispatch, getState))
            .catch(() => formalizeCallback(dispatch, getState));
    };

    validateAndExecute(dispatch, getState, callback);

};

const approveLoanRecord = () => (dispatch, getState) => {
    const recordId = getState().contractPayrollLoan.get('recordId', '');

    const params = {
        query: {
            recordId
        }
    };

    dispatch(simpleActions.contractPayrollLoanApproveRecord());

    return dispatch(contractPayrollLoanSaveInProgress()).then(() => {
        return APIPost({ dispatch, endpoint: 'payrollLoanApproveRecord', params })
            .then(response => {
                const preApprovalStatus = response.preApprovalStatus || '';
                if (preApprovalStatus === get(contractStatus, 'APPROVED')) {
                    dispatch(simpleActions.contractPayrollLoanApproveRecordApproved({ response }));
                } else {
                    dispatch(simpleActions.contractPayrollLoanApproveRecordError({ error: response }));
                }
            }).catch(response => {
                if (!!response.error) {
                    dispatch(simpleActions.contractPayrollLoanApproveRecordError({ error: response }));
                }
            });
    });
};

const hideNewOfferView = () => dispatch => {
    dispatch(approveLoanRecord()).then(() => {
        dispatch(simpleActions.contractPayrollLoanHideNewOfferView());
    });
};
const getPayrollLoanINE = (response) => (dispatch, getState) => {

    APIGet(dispatch, `${apiURLBuilder.getURL('loanContractDocuments')}/${response.operationProcessId}/${retailLoanCommons.NEW_RETAIL_LOAN_PRECONTRACTUAL}/documents`)
        .then(response => {
            const { base64Document, temporaryDocumentId } = response;
            dispatch(simpleActions.getPayrollLoanIneDocumentSuccess({ base64: base64Document, documentId: temporaryDocumentId }));
        })
        .catch(() => {
            dispatch(simpleActions.getPayrollLoanIneDocumentError());
        });

}
const getPayrollLoanExpedientINE = () => (dispatch, getState) => {
    const immPayrollLoanRequest = getState().contractPayrollLoan;
    const recordId = immPayrollLoanRequest.get('recordId')
    const documentType = retailLoanCommons.NEW_RETAIL_LOAN_PRECONTRACTUAL
    const params = {
        header: {
            version: 2
        },
    }
    return APIGet(dispatch, `${apiURLBuilder.getURL('recoverFileDocument')}/${documentType}/${recordId}`, params)
        .then((response) => {
            dispatch(simpleActions.getPayrollLoanExpedientIneSuccess({ response }));
            dispatch(getPayrollLoanINE(response))
        })

}
const getPayrollLoanPolicy = () => (dispatch, getState) => {
    const immPayrollLoanRequest = getState().contractPayrollLoan;
    const operationProcessId = immPayrollLoanRequest.get('payrollInitOperationProcessId')
    APIGet(dispatch, `${apiURLBuilder.getURL('loanContractDocuments')}/${operationProcessId}/${retailLoanCommons.NEW_RETAIL_LOAN_CONTRACT}/documents`)
        .then(response => {
            const { base64Document, temporaryDocumentId } = response;
            dispatch(simpleActions.getPayrollLoanPolicyDocumentSuccess({ base64: base64Document, documentId: temporaryDocumentId }));
        })
        .catch(() => {
            dispatch(simpleActions.getPayrollLoanPolicyDocumentError());
        });
}
const checkReadDocument = (checked) => (dispatch, getState) => {
    dispatch(simpleActions.contractPayrollLoanReadDocument(checked));
}
const checkRadioButton = (checked) => (dispatch, getState) => {
    dispatch(simpleActions.contractPayrollLoanCheckedRadioButton(checked));
}
const getInitParams = () => (dispatch, getState) => {
    const accounts = getState().accounts;
    const immPayrollLoan = getState().contractPayrollLoan;
    const selectedAccount = immPayrollLoan.get('selectedAccount');
    const immAccount = accounts.getIn(['byId', selectedAccount, 'iban']);
    const endOfMonth = immPayrollLoan.get('paymentDaySelected') === PAYMENT_DAY_END_OF_MONTH;
    const financedCommission = immPayrollLoan.get('indCapson') === amortizationTypes.YES ?
        FINANCIADA : NO_FINANCIADA;
    const immProposition = immPayrollLoan.get('proposition');
    const proccesTypeContract = retailLoanCommons.NEW_RETAIL_LOAN_CONTRACT
    const standard = immPayrollLoan.get('productStandard');
    const subType = immPayrollLoan.get('productSubType') ? immPayrollLoan.get('productSubType') : immPayrollLoan.get('subType');
    const type = immPayrollLoan.get('productType') ? immPayrollLoan.get('productType') : immPayrollLoan.get('type');
    const expedientOperationProcessId = immPayrollLoan.get('expedientOperationProcessId')

    return {
        query:
        {
            account: immAccount || 0,
            amount: formatAmount(immPayrollLoan.get('selectedAmount'), 'es'),
            calculatedOpeningCommission: formatAmount(immPayrollLoan.get('arrangementFee'), 'es'),
            capitalizedOpeningCommissionIndicator: immPayrollLoan.get('indCapson'),
            contractNumberAccount: 0,
            dueDate: moment(immProposition.get('loanDueDate')).format(DATE_FORMAT_WITH_SLASHES),
            endOfMonth: endOfMonth,
            financedCommission: financedCommission,
            firstTime: true,
            loanPurpose: immPayrollLoan.get('selectedPurposeDrago'),
            processType: proccesTypeContract,
            product: {
                standard,
                subType,
                type,
            },
            productDuration: immPayrollLoan.get('selectedTerm').toString(),
            productType: PRODUCT_TYPE,
            propositionContractNumber: immProposition.get('contractNumber'),
            propositionNumber: immProposition.get('propositionNumber', 0),
            tin: immPayrollLoan.get('tin'),
            tae: formatAmount(immPayrollLoan.get('tae'), 'es', 2),
            term: immPayrollLoan.get('selectedTerm'),
            year: immProposition.get('propositionYear'),
            attachedEvidences: [expedientOperationProcessId]
        }
    }
}
const getInitPayrollLoan = () => (dispatch) => {
    const params = dispatch(getInitParams());
    return APIPost({
        dispatch,
        endpoint: 'overdraftInit',
        params
    })
        .then((response) => {
            dispatch(simpleActions.contractPayrollLoanInitSuccess({ payrollInitOperationProcessId: response.operationProcessId }));
            dispatch(getPayrollLoanPolicy())
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractPayrollLoanInitError());
            } else {
                throw response;
            }
        });
}
const validateStep = currentStep => (dispatch, getState) => {
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const newPayrollLoanFF = immFlagBasedFeatures.get(NOT_ALLOWED_NEW_PERSONAL_LOAN_FLOW_COUNTRIES);
    if (newPayrollLoanFF) {
        if (currentStep.currentStep === WIZARD_FIRST_STEP) {
            const immPayrollLoanRequest = getState().contractPayrollLoan;
            const recordId = immPayrollLoanRequest.get('payrollInitOperationProcessId')
            dispatch(getProposition())
                .then(() => {
                    recordId ?
                        dispatch(simpleActions.contractPayrollLoanHiringIsFetchingDocuments()) :
                        dispatch(getPayrollLoanExpedientINE()).then(() => {
                            dispatch(getInitPayrollLoan())

                        })
                })
        }

    }

    dispatch(simpleActions.contractPayrollLoanValidateStep(currentStep))

};
const checkCheckedDocument = (checked) => (dispatch, getState) => {
    dispatch(simpleActions.contractPayrollLoanPrintDocument());
}
module.exports = {
    contractInitialize,
    downloadINEDocument,
    downloadLoanContractDocument,
    formalize,
    getHiringDocuments,
    getInstallment,
    getMinTerm,
    getProposition,
    hideNewOfferView,
    onDownloadDocument,
    onPrintDocument,
    setLoanAmountNewOffer,
    setLoanTermNewOffer,
    simpleActions,
    validateStep,
    checkReadDocument,
    checkRadioButton,
    checkCheckedDocument
};
